<template>
  <div class="pageContent">
    <div class="options">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="showAdd=true">添加会员卡组</el-button>
    </div>
    <div class="table_box">
      <el-table :data="tableData" border>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="是否默认" prop="show_default"></el-table-column>
        <el-table-column label="操作" width="285px">
          <template slot-scope="scope">
            <el-button type="text" @click="sendCoupon(scope.row.id)">发送优惠券</el-button>
            <el-button type="text" @click="gotoItem(scope.row.id)">进入会员卡组</el-button>
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <el-button type="text" v-if="scope.row.id!=0" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="showAdd" :title="formName" @close="closeAdd()" width="400px">
      <el-form size="small" label-width="90px">
        <el-form-item label="名称">
          <el-input class="form_input" v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="是否默认">
          <el-radio-group v-model="addForm.is_default">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="margin-top:20px;text-align:center">
          <el-button size="small" type="primary" @click="saveAdd()">保存</el-button>
          <el-button size="small" @click="closeAdd()">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showUser" title="全部会员" @close="closeUser()" width="600px"></el-dialog>
    <el-dialog :visible.sync="showSendCoupon" title="发送优惠券" @close="closeSend()" width="500px">
      <el-form size="small" label-width="80px">
        <el-form-item label="发送方式">
          <el-radio v-model="sendType" label="0">多券发送</el-radio>
          <el-radio v-model="sendType" label="1">单券多张</el-radio>
        </el-form-item>
        <el-form-item label="用户">会员卡组下全部用户</el-form-item>
        <el-form-item label="优惠券" v-if="sendType == '0'">
          <el-tag
            v-for="(tag,idx) in sList"
            :key="tag.id"
            closable
            @close="delTagItem(idx)"
            style="margin-bottom:5px;margin-right:5px;">
            {{tag.name}}
          </el-tag>
          <el-button size="small" @click="showSelecter=true">选择</el-button>
        </el-form-item>
        <el-form-item label="优惠券" v-if="sendType == '1'">
          <el-tag
            v-if="couponOne.id!=''"
            :key="couponOne.id"
            style="margin-bottom:5px;margin-right:5px;">
            {{couponOne.name}}
          </el-tag>
          <el-button size="small" @click="showSelecterOne=true">选择</el-button>
        </el-form-item>
        <el-form-item label="每人送" style="margin-bottom:5px" v-if="sendType == '1'">
          <el-input v-model="everyoneNum" placeholder="" size="small" style="width:100px;margin-right:5px;"></el-input>张
        </el-form-item>
      </el-form>
      <div style="text-align:center">
        <el-button type="primary" @click="clickSend()">发送</el-button>
        <el-button @click="closeSend()">取消</el-button>
      </div>
    </el-dialog>
    <!-- 选择优惠券弹窗 -->
    <!-- 多张优惠券发送1张 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity @close="showSelecter = false" @getCommod="getCommod" :sList="sList" :jude ="2" :menuName="'优惠券'"></selectCommodity>
    </el-dialog>
    <!-- 单张优惠券发送多张 -->
    <el-dialog :visible.sync="showSelecterOne" @close="showSelecterOne = false" width="460px">
      <selectCommodityOne @close="showSelecterOne = false" @getCommod="getCommodOne" :jude ="2"></selectCommodityOne>
    </el-dialog>
    <!-- 单券多张发送进度 -->
    <el-dialog 
      :visible.sync="showSendPro" 
      width="500px" 
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
      :show-close="false"
      title="发送优惠券"
      center>
      <div style="text-align:center">
        <div style="margin-bottom:20px">
          <el-progress type="circle" :percentage="sentPercent"></el-progress>
        </div>
        <div> <i class="el-icon-loading"></i> 正在发送优惠券，请勿关闭网页。</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { levelGroupList,levelGroupAdd,levelGroupEdit,levelGroupDel,levelGroupUids,levelGroupDetail,sendCoupon,sendCouponS } from '@/api/vip';
import { mapGetters } from "vuex";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import selectCommodityOne from "@/components/commodity/selectCommodity2.vue";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    selectCommodity,
    selectCommodityOne,
  },
  data(){
    return{
      tableData: [], // 表格数据
      showAdd: false, // 添加会员组弹窗
      addForm: {
        name: "",
        is_default: 0
      }, // 添加会员组表单
      showUser: false, // 显示全部会员
      formName: "添加会员卡组",
      is_add: true, // 是否是新增卡组
      sendType: "0", // 0.多券发布 1.单券多张
      uids: "", // 选择发送优惠券的卡组的用户uid
      showSendCoupon: false, // 发送优惠券表单弹窗
      sList: [], // 选择的优惠券列表
      everyoneNum: "", //单券多张 张数
      showSelecter: false, // 选择优惠券弹窗
      showSelecterOne: false, // 选择优惠券弹窗 单张
      couponOne: {id:""}, //单张优惠券信息
      sentPercent: 0, //单券多张发送进度
      showSendPro: false, //单券多张发送窗口
    }
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      levelGroupList(data).then(res => {
        if(res.code == 200){
          this.tableData = res.data;
          this.tableData.forEach(item => {
            item.show_default = item.is_default == 1? "是":"否"
          })
        }else{
          this.$message(res.msg)
        }
      })
    },
    delItem(id){
      console.log(id)
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: id
        }
        levelGroupDel(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      })
      .catch();
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    },
    gotoItem(id){
      console.log(id)
      this.$router.push({path: 'vip',query:{gid: id}})
    },
    showUserItem(){

      this.showUser = true;
    },
    closeUser(){
      this.showUser = false;
    },
    closeAdd(){
      this.addForm = {
        name: "",
        is_default: 0
      }
      this.showAdd = false;
      this.is_add = true;
      this.formName = "添加会员卡组"
    },
    saveAdd(){
      var data = Object.assign({},this.addForm)
      data.token = this.token;
      data.app_id = this.app_id;
      console.log(data)
      if(this.is_add){
        levelGroupAdd(data).then( res => {
          if(res.code == 200){
            this.$message.success('保存成功')
            this.showAdd = false;
            this.getData();
          }else{
            this.$message(res.msg)
          }
        })
      }else{
        levelGroupEdit(data).then( res => {
          if(res.code == 200){
            this.$message.success('保存成功')
            this.showAdd = false;
            this.getData();
          }else{
            this.$message(res.msg)
          }
        })
      }
    },
    editItem(row){
      this.is_add = false;
      this.formName = "编辑会员卡组"
      this.addForm = {
        id: row.id,
        name: row.name,
        is_default: row.is_default
      }
      this.showAdd = true;
    },
    sendCoupon(id){
      this.showSendCoupon = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        group_id: id
      }
      levelGroupUids(data).then(res => {
        if(res.code == 200) {
          this.uids = res.data.uids
        }else{
          this.$message.error('获取用户失败，请重试')
          this.showSendCoupon = false;
        }
      })
    },
    //删除已选择优惠券
    delTagItem(i){
      this.sList.splice(i,1)
    },
    //选择优惠券 单张
    getCommodOne(data){
      console.log(data);
      this.couponOne = data;
      this.showSelecterOne = false;
    },//选择优惠券
    getCommod(data){
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //发送
    clickSend(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        uid: this.uids,
        type_method: 1,
        batch: ""
      }
      // data.uid = this.sUserList.map(item => item.id).join(',');
      
      if(this.sendToAll){
        data.all = 1;
        data.type_method = 1;
        data.batch = ""
      }
      if(this.sendType == "0"){
        data.id = this.sList.map( i => i.id ).join(",");
        console.log(data);
        this.startSendCoupon2(data);
      }else{
        data.coupon_id = this.couponOne.id;
        data.num = this.everyoneNum;
        this.startSendCoupon(data);
      }  
      this.sentPercent = 0;
      this.showSendPro = true;
    },
    startSendCoupon(data){
      console.log("参数",data)
      var nextData = Object.assign({},data);
      sendCouponS(data).then(res => {
        if(res.code == 300){ //部分完成
          nextData.type_method = res.type_method;
          nextData.batch = res.batch;
          this.sentPercent = (Number(res.percent)*100).toFixed(0);
          this.startSendCoupon(nextData);
        }else if(res.code == 200){
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成"
          })
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
          }, 300);
        }else{
          this.$message(res.msg)
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      })
    },
    startSendCoupon2(data){
      console.log("参数",data)
      var nextData = Object.assign({},data);
      sendCoupon(data).then(res => {
        if(res.code == 300){ //部分完成
          nextData.type_method = res.type_method;
          nextData.batch = res.batch;
          this.sentPercent = (Number(res.percent)*100).toFixed(0);
          this.startSendCoupon2(nextData);
        }else if(res.code == 200){
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成"
          })
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
          }, 300);
        }else{
          this.$message(res.msg)
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      })
    },
    //关闭发送优惠券窗口
    closeSend(){
      this.sList = [];
      this.sUserList = [];
      this.selectUserName = "";
      this.showSendCoupon = false;
      this.CouponType = "0";
    },
  },
}
</script>

<style lang="scss" scoped>
.pageContent{
  border: 20px solid #f1f2f6;
  padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;
  .options{
    line-height: 79px;
  }
  .table_box{
    margin-bottom: 20px;
  }
  .form_input{
    width:240px;
  }
}
</style>